import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ShowHidePasswordModule } from "ngx-show-hide-password";
import { GenerateTokenComponent } from "./generateToken/generateToken.component";
import { ResetPasswordRoutingModule } from "./resetPassword-routing.module";
import { RouterModule } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { BreadcrumbModule } from "xng-breadcrumb";
import { ChangePasswordComponent } from "./changePassword/changePassword.component";
import { ResetPasswordComponent } from "./resetPassword.component";

@NgModule({
    declarations: [ResetPasswordComponent, GenerateTokenComponent, ChangePasswordComponent],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        SharedModule,
        BreadcrumbModule,
        ShowHidePasswordModule,
    ],
    exports: [ResetPasswordRoutingModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class ResetPasswordModule { }